<div id="bottomSheet">
  <h3 class="center">دوست دارید نرم افزار سایه رو روی تلفن همراهتون  داشته باشید ؟</h3>
  <div class="center">
    <p (click)="bottomSheetRef.dismiss()">خیر</p>
    <!--<p (click)="openLink()">بله</p>-->
    <a href="https://cafebazaar.ir/app/ir.sayeh.client/" target="_blank">بله</a>
    
  </div>
</div>
